/**
 * Includes script tag
 *
 * @param   {string}  URL       Script URL to include
 * @param   {string}  id       Script id to include
 * @param   {Function}  callback Callback function
 *
 */
export const loadScript = (URL, id, callback) => {
    const script = document.getElementById(id);

    if (script) {
        callback();
        return;
    }

    const documentTag = document;
    const tag = 'script';
    const object = documentTag.createElement(tag);

    object.setAttribute('id', id);

    object.src = '//' + URL;

    if (callback) {
        object.addEventListener('load', function (e) {
            callback(null, e);
        }, false);
    }

    document.head.appendChild(object);
};

/**
 * Remove script from head
 *
 * @param  {string} id Script tag id.
 */
export const removeScript = (id) => {
    const script = document.getElementById(id);

    script.parentNode.removeChild(script);
};
